import {
  ERROR_ACCOUNT_BLOCKED,
  ERROR_ACCOUNT_NOT_FOUND,
  ERROR_GMAIL_DOMAIN,
} from './constants.login';

const USER_EMAIL_ERRORS = [
  ERROR_GMAIL_DOMAIN,
  ERROR_ACCOUNT_BLOCKED,
  ERROR_ACCOUNT_NOT_FOUND,
];

export const IsUserEmailError = (res) => {
  const { error } = res || {};
  if (!error) return false;
  return USER_EMAIL_ERRORS.some((err) => error.includes(err));
};
